import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function PublicJumpToHomeButton() {
  const [dismissed, setDismissed] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage || i18n.language;
  const isRtl = String(lang || '').toLowerCase().startsWith('ar');
  const isEnglish = String(lang || '').toLowerCase().startsWith('en');
  const installLabel = isRtl ? 'تثبيت' : isEnglish ? 'Install' : 'Installer';

  const isOnHome = location.pathname === '/' || location.pathname === '/explore';

  const handleClick = () => {
    const section = document.getElementById('telecharger');

    if (isOnHome && section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    navigate('/explore#telecharger');

    // Wait for route render before trying smooth scroll to the section.
    window.setTimeout(() => {
      document.getElementById('telecharger')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 320);
  };

  if (dismissed) return null;

  return (
    <button
      type="button"
      onClick={handleClick}
      className="bc-public-jump-btn right-4 sm:right-6"
      aria-label={t('new_home.install_fab_title', {
        defaultValue: 'Installer notre app'
      })}
      title={t('new_home.install_fab_title', {
        defaultValue: 'Installer notre app'
      })}
    >
      <span
        role="button"
        tabIndex="0"
        className="bc-public-jump-btn__close"
        aria-label={isRtl ? 'سكر' : isEnglish ? 'Close' : 'Fermer'}
        onClick={(event) => { event.stopPropagation(); setDismissed(true); }}
        onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); event.stopPropagation(); setDismissed(true); } }}
      >×</span>
      <span className="bc-public-jump-btn__trailing">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 5v10" />
          <path d="m8 12 4 4 4-4" />
          <path d="M5 20h14" />
        </svg>
        <span>{installLabel}</span>
      </span>
    </button>
  );
}
